import { useNavigate } from 'react-router';
import { Iconify } from '@classroom-ai/ui/components/iconify';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';

import { useActiveClass } from 'src/class/class-provider';

// ----------------------------------------------------------------------

/**
 * Pinned under the header while a lead views a colleague's class from the Department page
 * (epic #566). The header title already says whose class it is and that it's view only (epic
 * #617), so this is one slim line: the visit is logged, live help is allowed, and the ways back.
 */
export function ViewingBanner() {
  const navigate = useNavigate();
  const { viewing, activeClass, stopViewing } = useActiveClass();
  if (!viewing || !activeClass) return null;

  const first = viewing.teacherName.split(' ')[0];

  return (
    <Box
      role="status"
      sx={(theme) => ({
        position: 'sticky',
        top: 'var(--layout-header-desktop-height, 72px)',
        zIndex: theme.zIndex.appBar - 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        px: { xs: 1.5, md: 2 },
        py: 0.5,
        mb: 2,
        borderRadius: 1.5,
        color: 'info.darker',
        bgcolor: 'info.lighter',
        border: `1px solid ${theme.vars.palette.info.light}`,
        ...theme.applyStyles('dark', { color: 'info.lighter', bgcolor: 'info.darker' }),
      })}
    >
      <Iconify icon="solar:eye-bold" width={18} />
      <Typography variant="caption" sx={{ flex: '1 1 260px', fontWeight: 600 }}>
        Visits are logged for {first}. You can still help in live sessions.
      </Typography>
      <Button
        size="small"
        color="inherit"
        onClick={() => {
          stopViewing();
          navigate(paths.dashboard.department);
        }}
      >
        Back to Department
      </Button>
      <Button size="small" color="inherit" onClick={stopViewing}>
        Back to my classes
      </Button>
    </Box>
  );
}
